@if (!component.interchangeableGroup) {
  <div class="w-full inline-flex">
    <h4 class="text-gray-600 place-self-center">Alternativen</h4>
    <div class="inline-flex ml-auto divide-x divide-gray-400">
      <button type="button" class="themed-link list" (click)="useManualComponents()">Manuell festlegen</button>
    </div>
  </div>
} @else {
  <div class="flex flex-col text-base space-y-1">
    @for (alternative of component.interchangeableGroup.components; track $index) {
      <div class="w-full flex items-start gap-1" [class.pb-2]="$last">
        <button type="button" (click)="alternativeRemove(alternative)"
                class="text-red-400 hover:text-red-600 place-self-start mt-1.5 cursor-pointer w-7 shrink-0 text-center"
                [class.opacity-0]="component.isOptional() && $last && $first"
                [class.pointer-events-none]="component.isOptional() && $last && $first"
                aria-label="Option entfernen"
                matTooltip="Option entfernen" matTooltipPosition="right">
          <span class="align-middle text-lg icon-[ph--stack-minus-duotone]"></span>
        </button>
        <!-- Amount+price and the item-select stack on phones (select needs room), side by side at sm+. -->
        <div class="min-w-0 w-full flex flex-col gap-2 sm:flex-row sm:items-center">
          <!--
            `sm:basis-72` is a PREFERRED width, not a pinned one (no `shrink-0`): the amount/price group
            keeps its comfortable size on wide screens but gives room back to the item select instead of
            overflowing when the row gets narrow (#230).
          -->
          <app-unit-amount-field class="min-w-0 sm:basis-72"
                                 [item]="ItemService.getItemInItems(alternative.item!)"
                                 [showPrice]="true"
                                 [index]="$index"
                                 [(value)]="alternative.value"
                                 [(price)]="alternative.price"
                                 [(unit)]="alternative.unit"/>
          <div class="flex items-center gap-1 min-w-0 grow">
            <!--
              `for` must name the INNER input, not the `<ng-select>` host — a custom element is not labelable,
              so this field counted as unlabelled (axe `label`, critical). `labelForId` stamps the id onto the
              input ng-select renders. Same pattern as the navbar search.
            -->
            <label for="{{'alternative_selector_input_' + $index}}" class="sr-only">Item</label>
            <!--
              #236: portal the option list out of the composition editor's `#component-container`
              (`overflow-y-auto`), which is far shorter than the list and used to cut it off. The target is an
              INPUT rather than a hardcoded selector — `appendTo` throws when its selector matches nothing, so a
              hardcoded host id would take the whole page down the moment this widget is reused elsewhere.
              `NgSelectScrollAwareDirective` rides along on the `ng-select[appendTo]` selector and keeps the
              panel attached while the container scrolls.

              `alternative_selector_*`, not `item_selector_*`: this widget renders INSIDE the composition
              editor's component row, whose own select already uses `item_selector_{{$index}}` for both its id
              and its form-control name — so the two collided on every row (a duplicate DOM id, and two
              template-driven controls fighting over one name in the enclosing <form>).
            -->
            <ng-select name="{{'alternative_selector_' + $index}}" id="{{'alternative_selector_' + $index}}"
                       [(ngModel)]="alternative.item"
                       [appendTo]="panelAppendTo()"
                       labelForId="{{'alternative_selector_input_' + $index}}"
                       clearable="false"
                       class="grow min-w-0 ng-select cheqme-style block rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
              @for (item of ItemService.items; track item.id) {
                @if (item.category.items.includes(alternative.item!) || !alternative.filter) {
                  <ng-option [value]="item.id">{{ item.name }}</ng-option>
                }
              }
            </ng-select>
            <span class="w-8 shrink-0 text-center" matTooltip="Option {{ $index + 1 }}" matTooltipPosition="left">
              <span class="text-xl icon-[ph--stack-simple]"></span>
            </span>
          </div>
        </div>
      </div>
    }
    <div class="inline-flex">
      <button type="button" class="themed-link mx-auto place-self-center" (click)="alternativeAdd()">
        <span class="align-middle text-xl icon-[ph--stack-plus]"></span>
        <span class="align-middle pl-2 text-sm">Option hinzufügen</span>
      </button>
    </div>
  </div>
}
